import { render, staticRenderFns } from "./LoginTeacherByTokenPage.vue?vue&type=template&id=75ce68a5"
import script from "./LoginTeacherByTokenPage.vue?vue&type=script&lang=js"
export * from "./LoginTeacherByTokenPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports